import { IOption, IOptionGroup } from './types'

// Option Group Component
export const isOptionGroup = (option: IOption | IOptionGroup): option is IOptionGroup =>
  (option as IOptionGroup).options !== undefined
